import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { PAGE_SIZE } from '../../common/constants';
import { formatDate, formatToNumberRound, isEmptyArray, isNotEmpty } from '../../common/util.services';
import './enquiry-order-list.component.scss';
import { getOrderByEnquiryCode, getOrderByCostingCode, deleteOrder } from '..//../order//order.services';

const EnquiryOrderList = () => {
  const [title, setTitle] = useState<string>('');
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const [orderData, setOrderData] = useState(rows);
  const params = useParams()
  const enquiryCode = params.enquiryCode;
  const costingCode = params.costingCode;
  const columns: GridColDef[] = [
    { field: 'code', headerName: 'Code', filterable: false, sortable: false, editable: false, width: 120,
      renderCell: (params) => { return <div className="cell-link" 
      onClick={() => { openEditOrderPage(params.row) }}>{params.row.code}</div> }
    },
    { field: 'customer', headerName: 'Customer', filterable: false, sortable: false, editable: false, width: 160 },
    { field: 'type', headerName: 'Type', filterable: false, sortable: false, editable: false, width: 90 },
    { field: 'priority', headerName: 'Priority', filterable: false, sortable: false, editable: false, width: 65 },
    { field: 'orderValue', headerName: 'Price', filterable: false, sortable: false, editable: false, width: 90,
      valueFormatter: (orderValue: any) => formatToNumberRound(orderValue)
    },
    { field: 'poValue', headerName: 'PO Value', filterable: false, sortable: false, editable: false, width: 90,
      valueFormatter: (poValue: any) => formatToNumberRound(poValue)
    },
    { field: 'productCount', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params) => { return <div className="cell-link" 
      onClick={() => { openProductPage(params.row) }}>{params.row.productCount}</div> }
    },
    { field: 'enquiryCode', headerName: 'Enq Code', filterable: false, sortable: false, editable: false, width: 125 },
    { field: 'status', headerName: 'Status', filterable: false, sortable: false, editable: false, width: 60 },
    { field: 'orderDate', headerName: 'Order Date', filterable: false, sortable: false, editable: false, width: 90,
      valueFormatter: (orderDate: any) => formatDate(orderDate)
    },
    { field: 'scheduleCount', headerName: 'Schedule', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params) => { return <div className="cell-link" 
      onClick={() => { openSchedulePage(params.row) }}>{params.row.scheduleCount}</div> }
    },
    { field: 'projectManager', headerName: 'Supervisor', filterable: false, sortable: false, editable: false, width: 150,
    },
    { field: 'orderAge', headerName: 'Ageing', filterable: false, sortable: false, editable: false, width: 65 }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      if(isNotEmpty(enquiryCode)) {
        getOrderByEnquiryCode(enquiryCode, page, pageSize, appContext,
          (response: any) => {
            setOrderData(response.data.data);
            setTotalRows(response.data.totalElements);
            setTitle('Orders For Enquiry');
            appContext.setShowLoader(false);
            setLoading(false);
          }, (error: any) => {
            appContext.setShowLoader(false);
            appContext.setErrorMessage(error.message);
            setLoading(false);
          });
      } else {
        getOrderByCostingCode(costingCode, page, pageSize, appContext,
          (response: any) => {
            setOrderData(response.data.data);
            setTotalRows(response.data.totalElements);
            setTitle('Orders For Costing');
            appContext.setShowLoader(false);
            setLoading(false);
          }, (error: any) => {
            appContext.setShowLoader(false);
            appContext.setErrorMessage(error.message);
            setLoading(false);
          });
      }
    }
  }, [page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const openEditOrderPage = (row: any) => {
      navigate('/enquiry/order/' + row.rowId, {state: {enquiryCode: row.enquiryCode, 
                                                       customer: row.customer,
                                                       product: row.product,
                                                       description: row.description}});
  };

  const openProductPage = (row: any) => {
    navigate('/order/product/' + row.rowId, {state: {enquiryCode: row.enquiryCode, 
                                                     customer: row.customer,
                                                     product: row.product,
                                                     description: row.description}});
  };

  const openSchedulePage = (row: any) => {
    navigate('/production/schedule/' + row.code + '/list', {state: {orderId: row.rowId, orderCode: row.code}});
  };

  const handleDeleteAction = (row: any) => {
    if(row.pojo > 0) {
      appContext.setDialogMessage('The order has a PO/JS. Delete the PO/JS first.');
    } else {
      deleteOrder(row.rowId, appContext,
        (response: any) => {
          navigate(0);
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
        });
    }
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={orderData} columns={columns} loading={loading} showAddBtn={false}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows} showEditAction={false}
        showApproveAction={false} showDeleteAction={true} handleDeleteAction={handleDeleteAction} showUpAction={false} showDownAction={false}
        showAction={true} getRowId={(row: any) => row.rowId} handleEditAction={openEditOrderPage}/>
    </>
  }

  return <TitlePanel title={title} panelBody={getMainPanel()} />
}

export default EnquiryOrderList;